import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../Layout';
import { getProduct } from '../../user/apiUser';
import { API } from '../../config';
import EmailValidator from 'email-validator';
import BuyButton from './BuyButton';
var shippo = require('shippo')('shippo_test_78a3a7e8883b86a4f9d562017f313dfd9b24fb71');

const GuestCheckout = () => {
    const [product, setProduct] = useState({});
    const { productId } = useParams();
    const [addressTo, setAddressTo] = useState({});

    const [values, setValues] = useState({
        name: '',
        street1: '',
        city: '',
        state: '',
        zip: '',
        country: 'US',
        email: '',
    });
    const { name, street1, city, state, zip, country, email } = values;

    const handleChange = name => event => {
        const value = event.target.value;
        setValues({...values, [name]: value})
    };

    useEffect(() => {
        getProduct(productId).then(data => {
            console.log(data);
            setProduct(data);
        });
    },[])

    const showError = () => (
        <div className="rounded-md bg-red-50 p-4" style={{display: error ? '' : 'none'}}>
            <div className="flex">
                <div className="ml-3">
                    <div className="mt-2 text-sm text-red-700 ">
                        <p className='pl-5 space-y-1'> {error} </p>
                    </div>
                </div>
            </div>
        </div>
    );

    const [showPaypal ,setShowPaypal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onContinueClick = async (event) => {
        event.preventDefault();
        setError('');
        setLoading(true);

        if (!email) {
            setError('Email cannot be left empty');
            setLoading(false);
            return 
        }
        else {
            if (!EmailValidator.validate(email)) { //I know im a poser :( 
                setError('Please enter a valid email');
                setLoading(false);
                return 
            }
        }
        
        //validate shipping
        const addrTo = { name, street1, city, state, zip, country, validate: true };
        setAddressTo(addrTo);
        await shippo.address.create(addrTo, async (err, address) => {
            const { validation_results } = await address;
            console.log(validation_results);
            if (err) {
                setError(err);
            }
            else if (!validation_results.is_valid) {
                setError(validation_results.messages[0].text);
            }
            else {
                console.log('address successfuly validated');
                setShowPaypal(true);
            }
        });

        setLoading(false);
    };

    return (
        <Layout>
            <div className="bg-gray-50">
                <div className="max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <h2 className="sr-only">Guest Checkout</h2>

                    <form className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
                        <div>
                            <div>
                                <h2 className="text-lg font-medium text-gray-900">Contact information</h2>

                                <div className="mt-4">
                                    <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
                                        Email address
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            type="email"
                                            onChange={handleChange('email')}
                                            value={email}
                                            id="email-address"
                                            name="email-address"
                                            autoComplete="email"
                                            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mt-10 border-t border-gray-200 pt-10">
                                <h2 className="text-lg font-medium text-gray-900">Shipping information</h2>

                                <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                                    <div>
                                        <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                                            Full name
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                type="text"
                                                onChange={handleChange('name')}
                                                value={name}
                                                id="first-name"
                                                name="first-name"
                                                autoComplete="given-name"
                                                className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                        </div>
                                    </div>

                                    <div className="sm:col-span-2">
                                        <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                                            Street
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                type="text"
                                                onChange={handleChange('street1')}
                                                value={street1}
                                                name="address"
                                                id="address"
                                                autoComplete="street-address"
                                                className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="city" className="block text-sm font-medium text-gray-700">
                                            City
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                type="text"
                                                onChange={handleChange('city')}
                                                value={city}
                                                name="city"
                                                id="city"
                                                autoComplete="address-level2"
                                                className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                            State
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                type="text"
                                                onChange={handleChange('state')}
                                                value={state}
                                                name="region"
                                                id="region"
                                                autoComplete="address-level1"
                                                className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700">
                                            Zip code
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                type="text"
                                                onChange={handleChange('zip')}
                                                value={zip}
                                                name="postal-code"
                                                id="postal-code"
                                                autoComplete="postal-code"
                                                className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        {/* Order summary */}
                        <div className="mt-10 lg:mt-0">
                            <h2 className="text-lg font-medium text-gray-900">Order summary</h2>

                            <div className="mt-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                                <h3 className="sr-only">Items in your cart</h3>
                                <div className='divide-y divide-gray-200'>
                                    <div className='flex py-6 px-4 sm:px-6'>
                                <div className="flex-shrink-0">
                                    <img src={`${API}/static/product_photos/${product.primary_photo}`} alt='primary_photo' className="rounded-md w-32" />
                                </div>

                                <div className="ml-6 flex-1 flex flex-col">
                                    <div className="flex">
                                        <div className="min-w-0 flex-1">
                                            <h4 className="text-sm">
                                                <a className="font-medium text-gray-700 hover:text-gray-800">
                                                    {product.name}
                                                </a>
                                            </h4>
                                            <p className="mt-1 text-sm text-gray-500">{product.brand}</p>
                                            <p className="mt-1 text-sm text-gray-500">{product.size}</p>
                                        </div>

                                        <div className="ml-4 flex-shrink-0 flow-root">
                                        </div>
                                    </div>

                                    <div className="flex-1 pt-2 flex items-end justify-between">
                                        <p className="mt-1 text-sm font-medium text-gray-900">${product.price}</p>

                                    </div>
                                </div>
                                </div>
                                </div>
                                { /*
                                <dl className="border-t border-gray-200 py-6 px-4 space-y-6 sm:px-6">
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Subtotal</dt>
                                        <dd className="text-sm font-medium text-gray-900">$64.00</dd>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Shipping</dt>
                                        <dd className="text-sm font-medium text-gray-900">$5.00</dd>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Taxes</dt>
                                        <dd className="text-sm font-medium text-gray-900">$5.52</dd>
                                    </div>
                                    <div className="flex items-center justify-between border-t border-gray-200 pt-6">
                                        <dt className="text-base font-medium">Total</dt>
                                        <dd className="text-base font-medium text-gray-900">$75.52</dd>
                                    </div>
                                </dl>
                                */}

                                    {showError()}
                                <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                                    {/* Maybe put a transition here so that it fades or slides in */}
                                    {showPaypal ? 
                                        <>
                                        <p className='text-sm text-gray-500'> Note: the address entered on paypal doesn't reflect where this item will be shipped</p>
                                        <BuyButton item={product} addrTo={addressTo} email={email}/>
                                        </>
                                        :
                                    <button
                                        type="button"
                                        onClick={onContinueClick}
                                        className="w-full bg-indigo-600 border border-transparent rounded-md shadow-sm py-3 px-4 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500"
                                    >
                                        {loading ? 'Validating address...' : 'Continue to payment'}
                                    </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
};

export default GuestCheckout;
